import { Users, X, Heart, Calendar, Shield } from "lucide-react";

export const ANNOUNCEMENTS = [
  // {
  //   priority: "high",
  //   icon: Users,
  //   title: "Company All-Hands Meeting",
  //   category: "MEETING",
  //   description: "Join us this Friday at 3 PM for quarterly updates and Q4 strategic planning",
  //   dateAnnounced: "Oct 15, 2025",
  //   time: "3:00 PM",

  // },
  // {
  //   priority: "medium",
  //   icon: Heart,
  //   title: "New Health Benefits Available",
  //   category: "BENIFITS",
  //   description: "Enhanced health coverage options now available for enrollment through the employee portal",
  //   dateAnnounced: "Oct 12, 2025",
  //   time: "All Day",

  // },
  // {
  //   priority: "low",
  //   icon: Calendar,
  //   title: "Office Closure - Thanksgiving",
  //   category: "HOLIDAY",
  //   description: "Offices will be closed Nov 28-29 for the holiday. Enjoy time with your family!",
  //   dateAnnounced: "Oct 10, 2025",
  //   time: "Nov 28-29",

  // },
];